import {MutableRefObject} from 'react';
import {IconButton} from '@mui/material';
import {CopyAll} from '@mui/icons-material';
import Toast from '../../package/Toaster';

const CopyToClipboardButton = ({
  inputRef,
}: {
  inputRef: MutableRefObject<HTMLInputElement | null>;
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(inputRef.current?.value ?? '');
    Toast('Copied to clipboard', 'success');
  };

  return (
    <IconButton
      onClick={handleCopy}
      color='primary'
      aria-label='Copy to clipboard'>
      <CopyAll />
    </IconButton>
  );
};

export default CopyToClipboardButton;

export const CopyOnlyStringToClipBoard = ({
  value,
  title,
}: {
  value: string;
  title?: string;
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    Toast('Copied to clipboard', 'success');
  };

  return (
    <IconButton
      onClick={handleCopy}
      color='primary'
      title={title || 'Copy text'}>
      <CopyAll />
    </IconButton>
  );
};
